import { useSnackbar } from "notistack";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import Backdrop from "@mui/material/Backdrop";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import { baseUrl } from "../../baseUrl";
import { VALIDATOR_EMIAL } from "../../shared/util/validators";
import jMoment from "moment-jalaali";

import EditUser from "./EditUser";

const UserInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [data, setData] = useState();
  const [userId, setUserId] = useState();

  const [reload, setReload] = useState(true);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
    setReload((prev) => !prev);
  };

  let prefix;
  if (auth.type === "laboratory") {
    prefix = "لابراتوار";
  } else {
    if (auth.type === "doctor") {
      prefix = "مطب";
    } else {
      prefix = "";
    }
  }

  // getting old values
  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/users/get-profile",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setData(response.data.data); // Output the response data
        setUserId(response.data.data.id);
        setIsLoading(false);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
        setIsLoading(false);
      });
  }, [reload]);

  //test
  useEffect(() => {
    console.log(data);
  }, [data]);

  const theme = useTheme();

  return (
    <>
      <Paper sx={{ flexGrow: 1, maxWidth: "1200px !important", p: 2 }}>
        <Modal open={open1} onClose={handleClose1}>
          <Box sx={style}>
            <EditUser
              id={userId}
              data={data}
              close={handleClose1}
              open={open1}
            />
          </Box>
        </Modal>
        <Typography variant="h5" align="center" sx={{ mb: 5 }}>
          اطلاعات کاربر
        </Typography>
        {isLoading ? (
          <>
            <CircularProgress color="inherit" />
          </>
        ) : (
          <Grid container spacing={2}>
            <Grid
              item
              md={6}
              sm={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Box
                  component="img"
                  src="https://placehold.co/160" // Replace with the actual image source
                  alt="User"
                  sx={{ width: 160, height: 160, borderRadius: "5%" }}
                />
              </Box>
            </Grid>

            <Grid item md={6} sm={12} sx={{ textAlign: "start" }}>
              <Typography color="primary" gutterBottom>
                {`${prefix} ${auth.name}`}
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {data.name} {data.lastName}
                <hr />
              </Typography>
              <Typography variant="body2" color="secondary" sx={{ mb: 1 }}>
                • نام کاربری : {data.username}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • ایمیل : {data.email}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • شماره همراه : {data.phoneNumber}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • شماره تلفن : {data.number}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • آدرس : {data.address}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • استان : {data.location.provinceName}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                • شهر : {data.location.cityName}
              </Typography>
              <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                • پایان اشتراک :
                {jMoment(Number(data.plan.endDate)).format("jYY/jMM/jDD")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth={true}
                variant="contained"
                color="primary"
                onClick={handleOpen1}
                sx={{ mt: theme.spacing(2) }}
              >
                ایجاد تغییرات
              </Button>
            </Grid>
          </Grid>
        )}
      </Paper>
    </>
  );
};

//   <>
//   <form>
//     <Grid container spacing={2}>
//       <Grid md={6} xs={12}>
//         <Input
//           id="companyName"
//           element="input"
//           label="نام کسب و کار"
//           validators={[VALIDATOR_REQUIRE()]}
//           errorText="لطفا نام کسب و کار را وارد کنید."
//           onInput={inputHandler}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="email"
//           element="input"
//           label="ایمیل"
//           validators={[VALIDATOR_EMIAL()]}
//           errorText="لطفا ایمیل خود را وارد کنید."
//           onInput={inputHandler}
//           inputValid={true}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="name"
//           element="input"
//           label="نام مدیر"
//           validators={[VALIDATOR_REQUIRE()]}
//           errorText="لطفا نام مدیر را انتخاب کنید."
//           onInput={inputHandler}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="lastname"
//           element="input"
//           label="نام خانوادگی مدیر"
//           validators={[VALIDATOR_REQUIRE()]}
//           errorText="لطفا نام خانوادگی مدیر را انتخاب کنید."
//           onInput={inputHandler}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="province"
//           element="autoComplete"
//           label="استان"
//           validators={[VALIDATOR_AUTOCOMPLETE()]}
//           errorText="لطفا استان را انتخاب کنید."
//           onInput={inputHandler}
//           options={provinces}
//           getOptionLabel={(option) => option.provinceName}
//           required={true}
//           initialValue={formState.inputs.province.value}
//           inputValid={formState.inputs.province.isValid}
//         />
//       </Grid>
//       {/*<Grid md={6} xs={12}>
//                        <Input
//                             id="city"
//                             element="autoComplete"
//                             label="شهر"
//                             validators={[VALIDATOR_AUTOCOMPLETE()]}
//                             errorText="لطفا شهر را انتخاب کنید."
//                             onInput={inputHandler}
//                             options={cities.map((city) => city.cityName)}
//                             required={true}
//                             inputValid={false}
//                             getOptionLabel={(option) => option}
//                        />
//                   </Grid> */}
//       <Grid md={12} xs={12}>
//         <Input
//           id="address"
//           element="input"
//           label="آدرس"
//           validators={[VALIDATOR_VALIDATED()]}
//           errorText="لطفا آدرس خود را وارد کنید."
//           onInput={inputHandler}
//           inputValid={true}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="number"
//           element="number_only"
//           label="شماره تلفن"
//           validators={[
//             VALIDATOR_VALIDATED(),
//             VALIDATOR_NUMBER_ONLY(),
//           ]}
//           errorText="لطفا شماره تلفن را وارد کنید. این مقدار باید فقط شامل اعداد باشد."
//           onInput={inputHandler}
//           inputValid={true}
//         />
//       </Grid>
//       <Grid md={6} xs={12}>
//         <Input
//           id="phoneNumber"
//           element="number_only"
//           label="شماره همراه"
//           validators={[
//             VALIDATOR_VALIDATED(),
//             VALIDATOR_NUMBER_ONLY(),
//           ]}
//           errorText="لطفا شماره همراه را وارد کنید. این مقدار فقط باید شامل اعداد باشد."
//           onInput={inputHandler}
//         />
//       </Grid>

//       <Grid xs={12}>
//         <Button
//           type="submit"
//           disabled={!formState.isValid}
//           fullWidth
//           color="secondary"
//           variant="contained"
//         >
//           اعمال تغییرات
//         </Button>
//       </Grid>
//     </Grid>
//   </form>
// </>

export default UserInfo;
